/* =============================================================================
   vp-newsletter-cart.js — Newsletter-Einladung beim Verweilen im Warenkorb
                                                                   (20.10.2026)

   Wunsch Ursula/Gabor/Doris: Auf der Startseite erscheint jetzt das
   Geschenk-Pop-up (sections/vp-gift-popup.liquid). Die Newsletter-Einladung
   soll spaeter kommen — wenn jemand im Warenkorb verweilt.

   ---------------------------------------------------------------------------
   WIE

   Das Newsletter-Pop-up ist die Theme-Sektion "Pop-up" in der Footer-Gruppe.
   Sie steht seit 20.10. auf "Nur auf der Startseite: aus", damit sie auf
   jeder Seite im Markup liegt (die Warenkorb-Schublade geht ueberall auf).
   Ihr eigener Zeitgeber aus PromoPopup.init() (global.js) laeuft weiter,
   darf das Pop-up aber nicht mehr oeffnen: diese Datei ersetzt openPopup()
   AM ELEMENT durch eine Pruefung. Erlaubt ist das Oeffnen nur noch

     a) durch den Warenkorb-Ausloeser unten,
     b) fuer die Bestaetigung nach einer Anmeldung (vp-newsletter-popup.js
        oeffnet das Pop-up dann selbst; erkennbar an der Erfolgs- bzw.
        Fehlermeldung des Theme-Formulars im Pop-up),
     c) im Theme-Editor (dort laeuft alles wie vom Theme vorgesehen).

   Warum nicht in sections/popup.liquid: die Datei ist 97 KB gross; fuer eine
   Zeile muesste sie komplett neu geschrieben werden. Das Ersetzen am Element
   ist dasselbe Verfahren, das vp-newsletter-popup.js schon verwendet
   (popupStilllegen), und kommt rechtzeitig: global.js und diese Datei laden
   beide mit defer, global.js zuerst; der Zeitgeber des Themes feuert erst
   nach 30 Sekunden.

   Warenkorb-Ausloeser:
     - Schublade geht auf (Ereignis "cart-drawer:open" aus cart-drawer.js)
       oder die Warenkorb-Seite wird geladen  ->  Uhr startet;
     - Schublade geht wieder zu  ->  Uhr stoppt;
     - nach SEKUNDEN, wenn der Warenkorb noch offen ist, Artikel enthaelt und
       kein anderes Pop-up offen ist  ->  Newsletter-Pop-up oeffnen.
   Wer vorher zur Kasse geht, verlaesst die Seite — dann passiert nichts.

   WIEDERVORLAGE — eigener Merker statt Theme-Cookie (gemessen 20.10.2026):
   PromoPopup hoert auf "cart-drawer:open" und ruft dann closePopup() auf —
   auch wenn das Pop-up gar nicht offen ist. closePopup() setzt jedes Mal den
   7-Tage-Cookie. Wer die Warenkorb-Schublade oeffnet, haette die Einladung
   also nie zu sehen bekommen. Deshalb:
     - closePopup() am Element tut nichts, solange das Pop-up zu ist;
     - schliesst jemand das offene Pop-up (X, "Fenster schliessen", nach der
       Anmeldung automatisch), merkt sich diese Datei das in localStorage
       fuer so viele Stunden, wie beim Pop-up unter "Frequenz" steht (7 Tage);
     - der Theme-Cookie wird fuer die Entscheidung nicht mehr herangezogen.

   ZURUECKNEHMEN: die Zeile fuer diese Datei in snippets/custom-assets.liquid
   entfernen und beim Newsletter-Pop-up "Nur auf der Startseite" wieder
   einschalten. Dann gilt wieder: Startseite, nach 30 Sekunden.
   ========================================================================== */

(function () {
  'use strict';

  var SEKUNDEN = 15;
  var FORM = 'form.promo-popup-newsletter-form';
  var MELDUNG = '[id^="Newsletter-success"], [id^="Newsletter-error"]';

  function entwurfsmodus() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function findPopup() {
    var all = document.querySelectorAll('promo-popup');
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector(FORM)) return all[i];
    }
    return null;
  }

  function cartPath() {
    var u = (window.routes && window.routes.cart_url) || '/cart';
    return u.replace(/\/$/, '');
  }

  function onCartPage() {
    return window.location.pathname.replace(/\/$/, '') === cartPath();
  }

  function drawerOpen() {
    var cd = document.querySelector('cart-drawer');
    return !!(cd && cd.classList.contains('active'));
  }

  function cartStillOpen() {
    return onCartPage() || drawerOpen();
  }

  function otherPopupOpen() {
    return !!(document.querySelector('.popup-wrapper.open') ||
              document.querySelector('vp-gift-popup.is-open') ||
              document.body.classList.contains('quick-view-open'));
  }

  function itemCount() {
    return fetch(cartPath() + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : { item_count: 0 }; })
      .then(function (c) { return (c && c.item_count) || 0; })
      .catch(function () { return 0; });
  }

  function init() {
    var pop = findPopup();
    if (!pop || entwurfsmodus()) return;
    if (pop.dataset.vpNlCart) return;
    pop.dataset.vpNlCart = '1';

    var name = pop.getAttribute('data-section-id') || 'newsletter';
    var stunden = parseInt(pop.getAttribute('data-frequency'), 10);
    if (!(stunden > 0) || stunden > 8760) stunden = 168;
    var KEY = 'vpNlZu:' + name;
    var proto = Object.getPrototypeOf(pop);
    var original = proto && proto.openPopup;
    var originalClose = proto && proto.closePopup;
    if (typeof original !== 'function' || typeof originalClose !== 'function') return;

    var erlaubt = false;

    function istOffen() {
      return !!document.querySelector('.popup-wrapper.open[data-popup-id="' + name + '"]');
    }

    // Erfolgs-/Fehlermeldung nach dem Absenden des Formulars? Sie liegt im
    // Element oder, wenn das Pop-up schon einmal offen war, im umgehaengten
    // Wrapper am Ende von <body>.
    function hatMeldung() {
      if (pop.querySelector(MELDUNG)) return true;
      var w = document.querySelector('.popup-wrapper[data-popup-id="' + name + '"]');
      return !!(w && w.querySelector(MELDUNG));
    }

    // Nur noch auf ausdrueckliche Erlaubnis oeffnen (siehe Kopf).
    pop.openPopup = function () {
      if (!erlaubt && !hatMeldung()) return;
      erlaubt = false;
      return original.apply(pop, arguments);
    };

    // Schliessen nur, wenn wirklich offen — sonst setzt das Theme bei jedem
    // Oeffnen der Warenkorb-Schublade den 7-Tage-Cookie (siehe Kopf).
    pop.closePopup = function () {
      if (!istOffen()) return;
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      var r = originalClose.apply(pop, arguments);
      // Ueber der offenen Schublade geschlossen: der Schliessen-Knopf des
      // Themes gibt dabei body.hidden frei (gemessen), die Seite hinter der
      // Schublade liesse sich dann scrollen. Zustand der Schublade wieder
      // herstellen.
      [350, 800].forEach(function (ms) {
        setTimeout(function () {
          if (!drawerOpen()) return;
          document.body.classList.add('hidden');
          var ov = document.querySelector('body > .overlay');
          if (ov) ov.classList.add('open');
        }, ms);
      });
      return r;
    };

    function weggeklickt() {
      try {
        var t = parseInt(localStorage.getItem(KEY), 10);
        return t > 0 && (Date.now() - t) < stunden * 3600 * 1000;
      } catch (e) {
        return false;
      }
    }

    var timer = null;

    function fire() {
      timer = null;
      if (weggeklickt() || !cartStillOpen() || otherPopupOpen()) return;
      itemCount().then(function (n) {
        if (!n || weggeklickt() || !cartStillOpen() || otherPopupOpen()) return;
        erlaubt = true;
        try { pop.openPopup(); } catch (e) {}
        erlaubt = false;
      });
    }

    function arm() {
      if (timer || weggeklickt()) return;
      timer = setTimeout(fire, SEKUNDEN * 1000);
    }

    function disarm() {
      if (timer) clearTimeout(timer);
      timer = null;
    }

    document.addEventListener('cart-drawer:open', function () { setTimeout(arm, 0); });
    document.addEventListener('body:visible', function () {
      if (!drawerOpen() && !onCartPage()) disarm();
    });
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () {
        if (!drawerOpen() && !onCartPage()) disarm();
      }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    }
    // Schublade war beim Laden schon offen (selten) oder Warenkorb-Seite
    if (drawerOpen() || onCartPage()) arm();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('promo-popup').then(function () {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    });
  }
})();
